import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { TPlani8State } from '../reducers';
import * as TExcelManagementActions from './excel-management.actions';
import { TUploadResponseDTO } from '@monorepo/services';
import { TExcelManagementContext, TExcelManagementInfo } from '../../types';

@Injectable({ providedIn: 'root' })
export class ExcelManagementFacade {
  constructor(private store: Store<TPlani8State>) {}

  downloadSampleTemplate(excelInfo: TExcelManagementInfo) {
    this.store.dispatch(new TExcelManagementActions.DownloadExcel(excelInfo));
  }

  downloadErrorTemplate(
    errorKey: Exclude<TUploadResponseDTO['errorFileKeyOpt'], undefined>,
    excelContext: TExcelManagementContext,
  ) {
    this.store.dispatch(new TExcelManagementActions.DownloadErrorExcel({ errorKey, excelContext }));
  }

  uploadExcel(file: File, excelInfo: TExcelManagementInfo) {
    this.store.dispatch(new TExcelManagementActions.UploadExcel({ file, excelInfo }));
  }
}
